import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print, checkPermission, SocketEvents } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal, Textarea } from 'components';
import { CleanIcon, CallIcon, WarningIcon, ThreePointsIcon } from 'assets/icons';
import { CallService, GeneralService } from 'services';
import ModalCreate from './modal-create';
import moment from 'moment';
import ModalPayment from 'components/modal-payment';
import { TYPES } from '../home/home';
import ModalRating from '../home/modal-rating';
import AddMembership from '../memberships/add-membership';
import { Alert } from 'assets/img';
import * as Jetemit from 'jetemit';

interface Props extends RootState, RouteComponentProps {
  dispatch: any;
}

const INITIAL_STATE = {
  search: '',
};

class Calls extends React.Component<Props> {
  timer: any = undefined;

  state = {
    header: ['Abogado', 'Motivo de consulta', 'Fecha', 'Hora', 'Estatus', 'Nro de ID'],
    form: INITIAL_STATE,
    data: [],
    page: 1,
    last_page: 1,
    item: null,
    visible: false,
    visible_consumed: false,
    visible_payment: false,
    visible_rating: false,
    visible_cancel: false,
    cancel_reason: '',
    menu_open_id: null as number | null,
    membership_status: Constants.ACCES_STATUS.ACCESS_DENIED,
    visible_membership: false,
    price: 0,
    unsubscriber: () => {},
  };

  componentDidMount() {
    this.props.dispatch({
      type: 'SET_HEADER',
      payload: {
        title: 'Llamadas Teléfonicas',
        onBack: null,
      },
    });

    this.props.dispatch({
      type: 'SET_SUBHEADER',
      payload: {
        title: '',
      },
    });

    this.setState({
      unsubscriber: Jetemit.on(SocketEvents.CALLS.STATUS_CHANGE, (data: any) => {
        if (Number(data.user_id) === Number(this.props.user?.id)) {
          this.load(true);
        }
      }),
    });

    this.load();
  }

  componentWillUnmount() {
    this.state.unsubscriber();
  }

  load = async (withoutLoading: boolean = false) => {
    try {
      const res: any = await CallService.get({
        withoutLoading,
        page: this.state.page,
        ...this.state.form,
        user_id: this.props.user?.id,
      });
      const selects: any = await GeneralService.getSelects({
        user_id: this.props.user?.id,
        services: true,
        service_id: Constants.SERVICES.CALL,
      });

      this.setState({
        data: res.rows,
        last_page: res.count,
        membership_status: res.membership_status,
        price: selects.services[0].price,
      });
    } catch (error) {}
  };

  reset = () => {
    this.setState(
      {
        form: INITIAL_STATE,
        page: 1,
      },
      () => this.load(true),
    );
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        page: 1,
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  openModal = () => {
    const { membership_status } = this.state;
    if (membership_status === Constants.ACCES_STATUS.ACCESS_LIMITED) {
      return this.setState({ visible_consumed: true });
    }
    if (membership_status === Constants.ACCES_STATUS.ACCESS_DENIED) {
      return this.setState({ visible_consumed: true });
    }
    if (membership_status === Constants.ACCES_STATUS.ACCESS_GRANTED) {
      return this.setState({ visible: true });
    }
  };

  onClose = (reload: boolean = false, visible: boolean = false) => {
    this.setState(
      {
        visible: visible,
        visible_consumed: false,
        visible_payment: false,
        visible_rating: false,
        visible_cancel: false,
      },
      () => {
        if (reload) {
          this.load(true);
        }
      },
    );
  };

  openModalPayment = () => {
    this.setState({
      visible_payment: true,
      visible_consumed: false,
    });
  };

  private openFacturaPdf = (relPathIn?: string) => {
    // relPathIn puede venir como string ('/storage/...') o como undefined
    if (!relPathIn) return;

    const base = (Constants.BASE_PUBLIC || '').replace(/\/+$/, '');
    const rel = relPathIn.startsWith('/') ? relPathIn : `/${relPathIn}`;
    const url = `${base}${rel}`;

    if ((window as any).webkit?.messageHandlers?.cordova_iab) {
      const payload = { message: 'open_url', url };
      (window as any).webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify(payload));
      return;
    }

    Print(url, true);
  };

  onSuccesPayment = async (data: any) => {
    try {
      const { user } = this.props;
      const res: any = await GeneralService.savePayment({
        user_id: user?.id,
        service_id: Constants.SERVICES.CALL,
        ...data,
      });

      // Soportar ambos formatos de respuesta:
      // a) facturaPDF.pdf.relPath => string
      // b) facturaPDF.pdf.relPath => { relPath: string, ... }
      const relPathObjOrStr = res?.facturaPDF?.pdf?.relPath;
      const relPath =
        typeof relPathObjOrStr === 'string' ? relPathObjOrStr : relPathObjOrStr?.relPath; // <- tomar el campo interno

      this.openFacturaPdf(relPath);

      Globals.showSuccess('Se ha enviado el pago correctamente, ya puede realizar una llamada');
      this.onClose(true, true);
    } catch (error) {
      console.error(error);
      Globals.showError('No se pudo registrar el pago');
    }
  };

  openMembership = () => {
    this.setState({
      visible_consumed: false,
      visible_membership: true,
    });
  };

  closeMembership = (reload: boolean = false) => {
    this.setState({
      visible_membership: false,
    });
    if (reload) {
      this.load(true);
    }
  };

  openCancelModal = (item: any) => {
    this.setState({
      visible_cancel: true,
      item,
      cancel_reason: '',
      menu_open_id: null,
    });
  };

  toggleMenu = (id: number) => {
    this.setState((prev: any) => ({
      menu_open_id: prev.menu_open_id === id ? null : id,
    }));
  };

  closeMenu = () => {
    this.setState({ menu_open_id: null });
  };

  // Whitelist invertida: coincide con los estados terminales que el backend
  // excluye en CallsService.cancel() (RESOLVED, NO_RESOLVED, CANCELLED). Cualquier
  // otro estado (PENDING, IN_PROCESS, REVIEW) sigue siendo cancelable mientras la
  // fecha de la llamada no haya llegado aún.
  canCancelCall = (item: any) => {
    const terminalStatuses = [
      Constants.CALL_STATUS.RESOLVED,
      Constants.CALL_STATUS.NO_RESOLVED,
      Constants.CALL_STATUS.CANCELLED,
    ];
    return !terminalStatuses.includes(item?.status) && moment(item?.day).isAfter(moment(), 'day');
  };

  cancelCall = async () => {
    if (!this.state.cancel_reason.trim()) {
      Globals.showError('Ingrese el motivo de la cancelación');
      return;
    }
    try {
      await CallService.cancel({
        id: (this.state.item as any)?.id,
        user_id: this.props.user?.id,
        reason: this.state.cancel_reason.trim(),
      });
      Globals.showSuccess('Llamada cancelada correctamente');
      this.onClose(true);
    } catch (error: any) {
      Globals.showError(error?.response?.data?.message || 'Error al cancelar la llamada');
    }
  };

  render() {
    const {
      visible,
      membership_status,
      visible_consumed,
      visible_payment,
      visible_rating,
      visible_membership,
      visible_cancel,
      cancel_reason,
      menu_open_id,
    } = this.state;
    return (
      <div id='client-calls'>
        <Modal
          className='modal-create-call'
          visible={visible}
          hideHeader={true}
          onClose={() => this.onClose()}
        >
          {/*// @ts-ignore */}
          <ModalCreate onClose={(reload: boolean) => this.onClose(reload)} />
        </Modal>

        <Modal
          id='modal-consumed-payment'
          visible={visible_consumed}
          title='Llamada telefónica'
          onClose={() => this.onClose()}
        >
          <img src={Alert} />
          <p className='title'>
            {membership_status === Constants.ACCES_STATUS.ACCESS_DENIED
              ? 'No tiene una membresía activa'
              : 'Usted ha consumido sus llamadas'}
          </p>
          <p>
            {membership_status === Constants.ACCES_STATUS.ACCESS_DENIED
              ? 'Puede comprar un uso de llamada realizando un pago'
              : 'Puede obtener el servicio mediante pago o esperar el próximo mes'}
          </p>

          <div className='btn-container'>
            {/* <button className='btn' onClick={() => this.openMembership()}>Adquirir membresía</button> */}
            <button className='btn btn-accept' onClick={this.openModalPayment}>
              Pagar
            </button>
          </div>
        </Modal>

        {
          <Modal
            className='modal-container-membership'
            visible={visible_membership}
            title=''
            onClose={() => this.closeMembership()}
          >
            {/* @ts-ignore */}
            <AddMembership membership_id={null} onClose={() => this.closeMembership(true)} />
          </Modal>
        }

        <Modal
          className='modal-rating'
          visible={visible_payment}
          title=''
          onClose={() => this.onClose()}
        >
          {/*// @ts-ignore */}
          <ModalPayment
            onClose={(reload: boolean) => this.onClose()}
            price={this.state.price}
            onSuccess={(data: any) => this.onSuccesPayment(data)}
            title='Llamada telefónica'
          />
        </Modal>

        <Modal
          className='modal-rating'
          visible={visible_rating}
          title='Calificar'
          onClose={() => this.onClose()}
        >
          {/*
		          // @ts-ignore */}
          <ModalRating
            item={this.state.item}
            type={TYPES.CALL}
            onClose={() => this.onClose(true)}
          />
        </Modal>

        <Modal
          className='modal-rating modal-cancel-call'
          visible={visible_cancel}
          title='Cancelar llamada'
          onClose={() => this.onClose()}
        >
          <div className='container-cancel-call'>
            <p>Indique el motivo por el cual desea cancelar esta llamada telefónica.</p>
            <Textarea
              rows={4}
              placeholder='Motivo de la cancelación'
              value={cancel_reason}
              onChange={(e: any) => this.setState({ cancel_reason: e.target.value })}
            />
            <div className='btn-container'>
              <button className='btn btn-accept' onClick={this.cancelCall}>
                Confirmar cancelación
              </button>
            </div>
          </div>
        </Modal>

        <div className='row row-filter'>
          <div className='col-md-12'>
            <div className='row'>
              <div className='col-md-4'>
                <Input
                  value={this.state.form.search}
                  name='search'
                  label='Buscar'
                  placeholder='Buscar'
                  className='input-table'
                  onSubmit={() => this.load()}
                  onChange={(e: any) => {
                    clearTimeout(this.timer);
                    this.timer = setTimeout(() => {
                      this.load(true);
                    }, 1000);
                    this.change(e);
                  }}
                />
              </div>
              <div className='col-md-1'>
                {this.state.form != INITIAL_STATE && (
                  <button className='btn btn-clean' onClick={() => this.reset()}>
                    <img src={CleanIcon} />
                  </button>
                )}
              </div>
              <div className='col-md-7 text-right'>
                <button className='btn btn-call' onClick={this.openModal}>
                  <p>Solicitar llamada teléfonica</p>
                  <div className='container-icon'>
                    <img src={CallIcon} />
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>

        <Table title='' data={this.state.data.length} header={this.state.header}>
          {this.state.data.map((i: any, index: number) => {
            const [start, end] = i.hour.split(',');
            const toFormatStart = moment(start, 'HH:mm').format('hh:mm A');
            const toFormatEnd = moment(end, 'HH:mm').format('hh:mm A');
            return (
              <tr key={index}>
                <td>{i?.lawyer ? i.lawyer?.full_name : 'No asignado'}</td>
                <td className='description'>
                  {i?.description ? (
                    <Tooltip title={i.description}>
                      <span className='description-text'>{i.description}</span>
                    </Tooltip>
                  ) : (
                    '-'
                  )}
                </td>
                <td>{moment(i?.day).format('DD-MM-YYYY')}</td>
                <td>
                  {toFormatStart} a {toFormatEnd}
                </td>
                <td>{i?.status_text}</td>
                <td className='code'>
                  {i?.number}
                  {this.canCancelCall(i) && (
                    <div className='kebab-container'>
                      <img
                        src={ThreePointsIcon}
                        className='kebab-btn'
                        onClick={() => this.toggleMenu(i.id)}
                      />
                      {menu_open_id === i.id && (
                        <>
                          <div className='kebab-backdrop' onClick={() => this.closeMenu()} />
                          <div className='kebab-dropdown'>
                            <p
                              onClick={() => {
                                this.closeMenu();
                                this.openCancelModal(i);
                              }}
                            >
                              Cancelar
                            </p>
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </td>
                {i?.status === Constants.CALL_STATUS.RESOLVED && i?.rating === null ? (
                  <td>
                    <button
                      className='btn btn-rating'
                      onClick={() => {
                        this.setState({
                          visible_rating: true,
                          item: i,
                        });
                      }}
                    >
                      {' '}
                      Calificar
                    </button>
                  </td>
                ) : (
                  <td></td>
                )}
              </tr>
            );
          })}
        </Table>

        <Pagination
          pages={this.state.last_page}
          active={this.state.page}
          onChange={async (page: number) => {
            await this.setState({
              page: page,
            });
            this.load();
          }}
        />
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(Calls);
